import React from "react";

export default function PageHeader({ title, subtitle, eyebrow, action, testId }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 lg:mb-8" data-testid={testId}>
      <div>
        {eyebrow && (
          <div className="text-xs uppercase tracking-[0.2em] text-emerald-700 font-semibold mb-2">{eyebrow}</div>
        )}
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tight text-gray-900">{title}</h1>
        {subtitle && <p className="text-gray-600 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
